import { timeToMinutes, minutesToTime, formatDate } from '@src/utils/moment.util.js'
import DATETIME_CONSTANT from '@src/constants/date-time-constants.js'
import GRAPH_CONSTANTS from '@src/constants/graph-constants.js'
const EMPTY_PERIOD = {
  EXTRA: 'extra',
  LABEL: 'empty',
  START_TIME: '00:00',
  END_TIME: '00:00',
  PRESENT: 0,
  BACKGROUND_COLOR: '#eaecf0',
  TEACHER: '',
}
export const fillEmptyTimeTable = (timeTable) => {
  const hasTeacher = timeTable.flat().some((item) => 'teacher' in item)

  const earliestTime = Math.min(
    ...timeTable.flat().map(({ start_time }) => timeToMinutes(start_time)),
  )

  const filledSchedule = timeTable.map((day) => {
    const filledDay = []

    day.forEach((lesson, i) => {
      // Insert empty slot before first lesson if needed
      if (i === 0 && timeToMinutes(lesson.start_time) > earliestTime) {
        filledDay.push({
          label: EMPTY_PERIOD.LABEL,
          start_time: minutesToTime(earliestTime),
          end_time: lesson.start_time,
          ...(hasTeacher ? { teacher: EMPTY_PERIOD.TEACHER } : { pres: EMPTY_PERIOD.PRESENT }),
          backgroundColor: EMPTY_PERIOD.BACKGROUND_COLOR,
        })
      }

      filledDay.push({ ...lesson, base: 0 })

      const nextLesson = day[i + 1]
      if (nextLesson && timeToMinutes(lesson.end_time) < timeToMinutes(nextLesson.start_time)) {
        filledDay.push({
          label: EMPTY_PERIOD.LABEL,
          start_time: lesson.end_time,
          end_time: nextLesson.start_time,
          ...(hasTeacher ? { teacher: EMPTY_PERIOD.TEACHER } : { pres: EMPTY_PERIOD.PRESENT }),
          backgroundColor: EMPTY_PERIOD.BACKGROUND_COLOR,
        })
      }
    })

    return filledDay
  })

  const maxDayLength = Math.max(...filledSchedule.map((day) => day.length))
  return filledSchedule.map((day) => {
    while (day.length < maxDayLength) {
      const lastLesson = day[day.length - 1]
      day.push({
        label: EMPTY_PERIOD.EXTRA,
        start_time: lastLesson?.end_time || EMPTY_PERIOD.START_TIME,
        end_time: lastLesson?.end_time || EMPTY_PERIOD.END_TIME,
        ...(hasTeacher ? { teacher: EMPTY_PERIOD.TEACHER } : { pres: EMPTY_PERIOD.PRESENT }),
      })
    }
    return day
  })
}

export const createGraphData = (timeTable) => {
  const maxLessons = Math.max(...timeTable.map((day) => day.length))
  const graphData = []

  for (let i = 0; i < maxLessons; i++) {
    const lessonData = timeTable.map((day) => day[i] || null)
    const validLessons = lessonData.filter((lesson) => lesson !== null)

    if (!validLessons.length) continue

    const hasPres = validLessons.some(
      (item) => 'pres' in item && item.pres !== null && item.pres !== undefined,
    )
    const hasTeacher = validLessons.some((item) => 'teacher' in item && item.teacher?.trim() !== '')

    const baseObject = {
      label: validLessons.map((lesson) => lesson.label),
      backgroundColor: validLessons.map((lesson) => lesson.backgroundColor),
      data: validLessons.map(
        (lesson) =>
          timeToMinutes(lesson.end_time, DATETIME_CONSTANT.TIME_24_WITHOUT_SECONDS) -
          timeToMinutes(lesson.start_time, DATETIME_CONSTANT.TIME_24_WITHOUT_SECONDS),
      ),
      base: 0,
    }

    if (hasPres) {
      baseObject.pres = validLessons.map((lesson) => lesson.pres)
    } else if (hasTeacher) {
      baseObject.teacher = validLessons.map((lesson) => lesson.teacher)
    }

    graphData.push(baseObject)
  }

  return graphData
}

export const findEarliestTime = (timeTable) => {
  const earliestMinutes = Math.min(
    ...timeTable
      .flat()
      .map(({ start_time }) =>
        timeToMinutes(start_time, DATETIME_CONSTANT.TIME_24_WITHOUT_SECONDS),
      ),
  )
  return {
    Hours: Math.floor(earliestMinutes / 60),
    Minutes: earliestMinutes % 60,
  }
}
export const transformScheduleData = (stats) => {
  return stats.flatMap((section) =>
    section.section_stat.map((day) =>
      day.subject_stats.map((subject) => {
        const base = {
          label: subject.subject_title,
          start_time: formatDate(subject.started_at, DATETIME_CONSTANT.TIME_24_WITHOUT_SECONDS),
          end_time: formatDate(subject.ended_at, DATETIME_CONSTANT.TIME_24_WITHOUT_SECONDS),
          backgroundColor: GRAPH_CONSTANTS.COLOR_CODE[subject.subject_color] || '#000000',
        }
        if (subject.total_present) {
          base.pres = subject.total_present
        } else if (subject.teacher_name) {
          base.teacher = subject.teacher_name
        } else base
        return base
      }),
    ),
  )
}
